// Application configuration and constants
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
export const VAPID_PUBLIC_KEY = process.env.REACT_APP_VAPID_PUBLIC_KEY;
export const DEFAULT_PB_SPECIES = ['Hecht', 'Barsch', 'Zander'];

export const ROLES = {
  USER: 'user',
  ADMIN: 'admin'
};

export const NOTIFICATION_TYPES = {
  CATCH_LIKE: 'catch_like',
  CATCH_COMMENT: 'catch_comment',
  GROUP_INVITE: 'group_invite',
  BUDDY_REQUEST: 'buddy_request',
  BUDDY_ACCEPTED: 'buddy_accepted',
  ACHIEVEMENT: 'achievement'
};
